const { createSlice } = require("@reduxjs/toolkit");
const initialState = {
  selectedId: [],
};
const ManageAdminSlicer = createSlice({
  name: "ManageAdmin",
  initialState,
  reducers: {
    getManageData: (state, action) => {
      if (state.selectedId.length < 1) {
        state.selectedId.push(action.payload);
      } else {
        state.selectedId[0] = action.payload;
      }
    },
  },
});
export const { getManageData } = ManageAdminSlicer.actions;
export default ManageAdminSlicer.reducer;
